<template>
    <div id="main-container" :class="[controlShow||isEmpty ? 'can-not-scroll' : 'can-scroll']">

        <div class="option-container" :class="[controlShow ? 'visible' : 'invisible']">
            <keep-alive>
                <NewSearchMain
                        v-if="controlShow"
                        @handleSearch="handleSearchButton"
                        @closeFilterPage="handleSearchButtonText(false)"
                        :locations="options"/>
            </keep-alive>
        </div>

        <appBar
                :icon-src="`./assets/ic_dorbom_logo.svg`"
                style="top: 0; z-index: 10; width: 100%"
                @onBack="goHome">

            <img src="../../assets/search.svg"
                 v-if="!controlShow"
                 style="position: absolute; width: 25px; height: 23px; right: 21px; top: 15px; z-index: 9999;"
                 @click="handleSearchButtonText(true)"/>
        </appBar>

        <div
                v-if="tags.length > 0"
                class="tags-container"
                ref="container">

            <div v-if="tags.length > 0" style="padding-bottom: 12px; max-width: 1024px;">
                <div v-if="isFlip">
                    <div class="tags-title" style="padding-top: 16px;">
                        <div style="margin-left: 16px; width: 100%; text-align: left;">
                            선택한 옵션
                        </div>
                    </div>

                    <div style="margin-top: 14px; overflow-x: scroll; overflow-y: hidden; padding-left: 16px; text-align: left;"
                         :class="[isFlip ? 'flip-container' : '']">

                        <div class="top-tag-item" style="margin-right: 8px; display: inline-block; height: auto;"
                             :class="[isFlip ? '' : 'non-flip-item']"
                             v-for="(tag, idx) in tags"
                             :key="idx">

                            <span>{{tag.label}}</span>

                            <div style="height: 12px; display: inline-block;">
                                <img v-if="tag.type != 'location'"
                                     src="../../assets/ic-delete.png"
                                     style="width: 12px; height: 12px; margin-left: 4px;"
                                     @click="handleRemoveFilterOption(tag.type)">
                            </div>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 20px;"
                     @click="handleTagFlip">
                    <img :src="flipSrc"
                         style="width: 10px; height: 5px; margin-right: 6px; justify-content: center; align-items: center; margin-bottom: 2px;">
                    <span class="flip-text">{{flipText}}</span>
                </div>
            </div>
        </div>

        <div class="list-container" :style="{paddingTop: listPaddingTop + 'px'}">
            <div style="padding-top: 20px;">
                <img src="../../assets/banner.png" style="width: 100%; display: block;"
                     @click="handleSearchButtonText(true)"/>
                <img src="../../assets/button.png" style="width: 100%; display: block;" @click="goApp()"/>
            </div>
            <ul style="padding-left: 0; margin: 0;">
                <list-item
                        v-for="(item, idx) in search_list"
                        :key="idx"
                        :lidx="item.lidx"
                        :idx="item.idx"
                        :title="item.title"
                        :income_type="item.income_type"
                        :income="item.income"
                        :childbirth_type="item.childbirth_type"
                        :child_birth="item.child_birth"
                        :apply_online="item.apply_online"
                        :require_card="item.require_card"
                        :multi_cultural="item.multi_cultural"
                        :disabled="item.disabled"
                        :second_tier="item.second_tier"
                        :basic_income="item.basic_income"
                        :one_parent="item.one_parent"
                        :detail_condition="item.detail_condition"
                        :detail_required_document="item.detail_required_document"
                        :detail_benefit="item.detail_benefit"
                        :detail_how_apply="item.detail_how_apply"
                        :detail_etc="item.detail_etc"
                        :summary_condition="item.summary_condition"
                        :summary_benefit="item.summary_benefit"
                        :apply_company="item.name"
                        :is_corona="item.is_corona"
                        :locations="options">

                </list-item>
            </ul>
        </div>
        <div class="not-exist" v-if="isEmpty && !controlShow">검색된 내역이 없습니다.</div>
    </div>
</template>

<script>

    import listItem from "./InformationListItem"
    import appBar from "@/components/common/app_bar";
    import NewSearchMain from "@/components/filter/NewSearchMain";
    import {EventBus} from "@/event-bus";
    import firebase from "firebase/app";
    import 'firebase/analytics'

    const {getLocationList} = require('../../Api');
    const {getSearchList} = require('../../Api');
    const {getGovermentList} = require('../../Api');

    export default {
        name: "information_main",
        components: {
            listItem,
            appBar,
            NewSearchMain
        },
        data() {
            return {
                pageOffset: 1,
                govermentPageOffset: 1,
                search_list: [],
                hasNextPage: false,
                govermentHasNextPage: false,
                previousScroll: 0,
                controlShow: false,
                searchInfo: [],
                isEmpty: false,
                requireGovermentList: false,
                options: [
                    {
                        value: 1,
                        label: '전국',
                        children: [
                            {
                                value: 1,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 2,
                        label: '서울시',
                        children: [
                            {
                                value: 2,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 29,
                        label: '경기도',
                        children: [
                            {
                                value: 29,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 32,
                        label: '강원도',
                        children: [
                            {
                                value: 32,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 36,
                        label: '경상북도',
                        children: [
                            {
                                value: 36,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 35,
                        label: '경상남도',
                        children: [
                            {
                                value: 35,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 34,
                        label: '충청북도',
                        children: [
                            {
                                value: 34,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 33,
                        label: '충청남도',
                        children: [
                            {
                                value: 33,
                                label: "전체"
                            }
                        ]
                    },
                    {
                        value: 37,
                        label: '제주도',
                        children: [
                            {
                                value: 37,
                                label: "전체"
                            }
                        ]
                    }
                ],
                tags: [],
                isFlip: true,
                flipSrc: './assets/ic_down_arrow.png',
                flipText: '닫기',
                listPaddingTop: 38,
                isSearchOpen: false
            }
        },
        beforeMount() {
            this.getLocation();

            let info = {
                title: "all",
                lidx: 1
            };

            this.searchInfo = info;

            this.getSearchList(this.searchInfo, this.pageOffset);
            window.addEventListener('scroll', this.handleScroll);

            EventBus.$on("resetEvent", () => {
                this.isEmpty = false;
                this.searchInfo = null;
                this.makeTags(this.searchInfo);
                this.listPaddingTop = 38;

                let info = {
                    title: "all",
                    lidx: 1
                };

                this.searchInfo = info;
                this.getSearchList(this.searchInfo, this.pageOffset);
            });
        },
        beforeDestroy() {

            let userAgent = navigator.userAgent;

            if (userAgent.match('mobile_user')) {
                if (userAgent.match('Android')) {
                    window.Dorbom.postMessage("searchBoxClose");
                } else if (userAgent.match('iPhone|iPad|iPod')) {
                    window.webkit.messageHandlers.callBackHandler.postMessage("searchBoxClose");
                }
            }

            window.removeEventListener('scroll', this.handleScroll);
            EventBus.$off("resetEvent");
        },
        methods: {
            postMessage(acion) {
                alert(acion)
                this.handleSearchButtonText(false)
            },
            goApp() {
                firebase.analytics().logEvent('clickAppLink', {
                    ts: this.getTs()
                });

                let userAgent = navigator.userAgent;

                if (userAgent.match('mobile_user')) {

                    if (userAgent.match('Android')) {
                        window.Dorbom.postMessage("playstore");
                    } else if (userAgent.match('iPhone|iPad|iPod')) {
                        window.webkit.messageHandlers.callBackHandler.postMessage("playstore");
                    }
                } else {
                    window.location.href = 'https://dorbom.page.link/n6m5'
                }
            },
            goHome() {
                window.location.reload();
            },
            getTs() {
                let date = new Date();

                let year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();

                if (month < 10) {
                    month = "0" + month
                }

                if (day < 10) {
                    day = "0" + day
                }

                if (hour < 10) {
                    hour = "0" + hour
                }

                if (minutes < 10) {
                    minutes = "0" + minutes
                }

                if (seconds < 10) {
                    seconds = "0" + seconds
                }

                return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
            },
            async getLocation() {
                let response = await getLocationList();

                let data = response.data;

                if (data.res == 0) {
                    let responseData = response.data.data;

                    this.setLocationList(responseData)
                }
            },
            setLocationList(list) {
                for (let i = 0; i < list.length; i++) {
                    let pidx = list[i].pidx;
                    let name = list[i].name;
                    let idx = list[i].idx;

                    this.importChildLocation(pidx, name, idx)
                }
            },
            importChildLocation(pidx, name, idx) {

                if (idx == 1)
                    return;

                for (let i = 0; i < this.options.length; i++) {

                    if (this.options[i].value == pidx) {
                        let model = {
                            value: idx,
                            label: name
                        };

                        this.options[i].children.push(model);
                        return;
                    }
                }
            },
            handleRemoveFilterOption(type) {

                console.log(type)

                for (let i = 0; i < this.tags.length; i++) {

                    if (this.tags[i].type == type) {
                        this.tags.splice(i, 1);
                        EventBus.$emit('removeFilterOption', type);
                        break;
                    }
                }

                if (this.tags.length == 0) {
                    this.listPaddingTop = 38;
                }
            },
            handleTagFlip() {
                this.isFlip = !this.isFlip;

                if (this.isFlip) {
                    this.flipSrc = './assets/ic_down_arrow.png';
                    this.flipText = '닫기';
                    this.listPaddingTop = 169;
                } else {
                    this.flipSrc = './assets/ic_up_arrow.png';
                    this.flipText = '열기';
                    this.listPaddingTop = 90;
                }
            },
            handleSearchButtonText(status) {
                this.controlShow = status;

                var postMessage = ''

                if (status == true) {
                    postMessage = "searchBoxOpen"
                } else {
                    postMessage = "searchBoxClose"
                }

                let userAgent = navigator.userAgent;

                if (userAgent.match('mobile_user')) {
                    if (userAgent.match('Android')) {
                        window.Dorbom.postMessage(postMessage);
                    } else if (userAgent.match('iPhone|iPad|iPod')) {
                        window.webkit.messageHandlers.callBackHandler.postMessage(postMessage);
                    }
                }
            },
            makeTags(searchInfo) {

                this.tags.splice(0, this.tags.length);

                if (searchInfo != null) {

                    if (searchInfo.parentLocation != null && searchInfo.childLocation) {

                        var locationLabel = searchInfo.parentLocation.label;

                        if (searchInfo.childLocation.label != '전체' &&
                            searchInfo.childLocation.label != '전국') {

                            locationLabel += " " + searchInfo.childLocation.label;
                        }

                        this.tags.push({
                            label: locationLabel,
                            type: 'location'
                        })
                    }

                    if (searchInfo.is_corona != null && searchInfo.is_corona != 2) {

                        var coronaLabel = '';

                        if (searchInfo.is_corona == 0) {
                            coronaLabel = '일반 지원';
                        } else {
                            coronaLabel = '코로나 지원';
                        }

                        this.tags.push({
                            label: coronaLabel,
                            type: 'corona'
                        })
                    }

                    if (searchInfo.child_birth_type != null && searchInfo.child_birth_type != 2) {

                        var childLabel = '';

                        if (searchInfo.child_birth_type == 0) {
                            childLabel = '임신 ' + searchInfo.child_birth + "개월"
                        } else {
                            childLabel = '출산 ' + searchInfo.child_birth + "개월"
                        }

                        this.tags.push({
                            label: childLabel,
                            type: 'birth'
                        })
                    }

                    if (searchInfo.income_type != null && searchInfo.income_type != 2) {

                        var incomeLabel = '';

                        if (searchInfo.income_type == 0) {
                            incomeLabel = '월 소득 ' + (parseInt(searchInfo.income)).toLocaleString() + "원"
                        } else {
                            incomeLabel = '건강보험료 ' + (parseInt(searchInfo.income)).toLocaleString() + "원"
                        }

                        this.tags.push({
                            label: incomeLabel,
                            type: 'income'
                        })
                    }

                    if (searchInfo.require_card != null && searchInfo.require_card == 1) {

                        this.tags.push({
                            label: '카드 필요',
                            type: 'requireCard'
                        })
                    }

                    if (searchInfo.multi_cultural != null && searchInfo.multi_cultural == 1) {

                        this.tags.push({
                            label: '다문화 가정',
                            type: 'multiCultural'
                        })
                    }

                    if (searchInfo.disabled != null && searchInfo.disabled == 1) {

                        this.tags.push({
                            label: '장애 여부',
                            type: 'disabled'
                        })
                    }

                    if (searchInfo.second_tier != null && searchInfo.second_tier == 1) {

                        this.tags.push({
                            label: '차상위계층',
                            type: 'secondTier'
                        })
                    }

                    if (searchInfo.one_parent != null && searchInfo.one_parent == 1) {

                        this.tags.push({
                            label: '한부모가정',
                            type: 'oneParent'
                        })
                    }

                    if (searchInfo.basic_income != null && searchInfo.basic_income == 1) {

                        this.tags.push({
                            label: '기초수급대상',
                            type: 'basicIncome'
                        })
                    }

                    if (this.isFlip)
                        this.listPaddingTop = 169;
                }
            },
            handleSearchButton(searchInfo) {

                this.search_list.splice(0, this.search_list.length);

                this.makeTags(searchInfo);

                this.pageOffset = 1;
                this.searchInfo = searchInfo;
                this.requireGovermentList = true;
                this.hasNextPage = false;
                this.govermentHasNextPage = false;
                this.getSearchList(this.searchInfo, this.pageOffset);

                this.handleSearchButtonText(false)
            },
            handleScroll() {

                var currentScroll = window.scrollY;
                var containerHeight = document.documentElement.scrollHeight - window.innerHeight;


                if (currentScroll >= containerHeight - 200) {

                    if (this.hasNextPage) {
                        this.getSearchList(this.searchInfo, ++this.pageOffset);
                    }

                    if (this.govermentHasNextPage) {
                        this.getGovermentList(this.searchInfo, ++this.govermentHasNextPage)
                    }
                }
            },
            async getSearchList(searchInfo, pageOffset) {

                var title = 'all';
                var lidx = 1;
                var birthType = 2;
                var childBirth = 0;
                var incomeType = 2;
                var income = 0;
                var requireCard = 0;
                var multiCultural = 0;
                var disabled = 0;
                var secondTier = 0;
                var oneParent = 0;
                var basicIncome = 0;
                var coronaType = 2;

                if (searchInfo.title != null) {
                    title = searchInfo.title;
                }

                if (searchInfo.is_corona != null) {
                    coronaType = searchInfo.is_corona;
                }

                if (searchInfo.childLocation != null) {
                    lidx = searchInfo.childLocation.value;
                }

                if (searchInfo.child_birth_type != null) {
                    birthType = searchInfo.child_birth_type;
                }

                if (searchInfo.child_birth != null) {
                    childBirth = searchInfo.child_birth;
                }

                if (searchInfo.income_type != null) {
                    incomeType = searchInfo.income_type
                }

                if (searchInfo.income != null) {
                    income = searchInfo.income
                }

                if (searchInfo.require_card != null) {
                    requireCard = searchInfo.require_card
                }

                if (searchInfo.multi_cultural != null) {
                    multiCultural = searchInfo.multi_cultural
                }

                if (searchInfo.disabled != null) {
                    disabled = searchInfo.disabled
                }

                if (searchInfo.second_tier != null) {
                    secondTier = searchInfo.second_tier
                }

                if (searchInfo.one_parent != null) {
                    oneParent = searchInfo.one_parent
                }

                if (searchInfo.basic_income != null) {
                    basicIncome = searchInfo.basic_income
                }

                let response = await getSearchList(title, lidx, coronaType, birthType, childBirth,
                    incomeType, income, requireCard, multiCultural, disabled,
                    secondTier, oneParent, basicIncome, pageOffset);

                let resCode = response.data.res;

                if (resCode == 0) {

                    let data = response.data.data;

                    for (let i = 0; i < data.support_list.length; i++) {
                        this.search_list.push(data.support_list[i]);
                    }

                    this.hasNextPage = data.support_list.length == 10;

                    if (!this.hasNextPage && lidx != 1) {

                        this.govermentPageOffset = 1;
                        this.getGovermentList(searchInfo, this.govermentPageOffset)
                    } else if (!this.hasNextPage && lidx == 1) {

                        if (this.search_list.length == 0) {
                            this.isEmpty = true;
                            console.log("asdfsdf")
                        } else {
                            this.isEmpty = false;
                        }
                    }
                } else {
                    this.isEmpty = true;
                }
            },
            async getGovermentList(searchInfo, pageOffset) {

                var birthType = 2;
                var childBirth = 0;
                var incomeType = 2;
                var income = 0;
                var requireCard = 0;
                var multiCultural = 0;
                var disabled = 0;
                var secondTier = 0;
                var oneParent = 0;
                var basicIncome = 0;
                var coronaType = 2;

                if (searchInfo.is_corona != null) {
                    coronaType = searchInfo.is_corona;
                }

                if (searchInfo.child_birth_type != null) {
                    birthType = searchInfo.child_birth_type;
                }

                if (searchInfo.child_birth != null) {
                    childBirth = searchInfo.child_birth;
                }

                if (searchInfo.income_type != null) {
                    incomeType = searchInfo.income_type
                }

                if (searchInfo.income != null) {
                    income = searchInfo.income
                }

                if (searchInfo.require_card != null) {
                    requireCard = searchInfo.require_card
                }

                if (searchInfo.multi_cultural != null) {
                    multiCultural = searchInfo.multi_cultural
                }

                if (searchInfo.disabled != null) {
                    disabled = searchInfo.disabled
                }

                if (searchInfo.second_tier != null) {
                    secondTier = searchInfo.second_tier
                }

                if (searchInfo.one_parent != null) {
                    oneParent = searchInfo.one_parent
                }

                if (searchInfo.basic_income != null) {
                    basicIncome = searchInfo.basic_income
                }

                let response = await getGovermentList(coronaType, birthType, childBirth,
                    incomeType, income, requireCard, multiCultural, disabled,
                    secondTier, oneParent, basicIncome, pageOffset);

                let resCode = response.data.res;

                if (resCode == 0) {

                    let data = response.data.data;

                    for (let i = 0; i < data.support_list.length; i++) {
                        this.search_list.push(data.support_list[i]);
                    }

                    this.govermentHasNextPage = data.support_list.length == 10;

                    if (this.search_list.length == 0) {
                        this.isEmpty = true;
                    } else {
                        this.isEmpty = false;
                    }
                }
            }
        }
    }
</script>

<style>

    body, html {
        width: 100%;
        height: 100%;
        margin: 0;
        background-color: #f8f8f8;
    }

    #main-container {
        z-index: 10;
        width: 100%;
        height: 100%;
    }

    .not-exist {
        position: absolute;
        z-index: 2000;
        width: 100%;
        top: 70%;
        text-align: center;
        vertical-align: text-bottom;
    }

    .option-container {
        overflow-y: auto;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: white;
        z-index: 1000;
    }

    .list-container {
        position: relative;
        bottom: 0;
        z-index: 0;
    }

    .can-scroll {

    }

    .can-not-scroll {
        overflow: hidden;
    }

    .invisible {
        display: none;
    }

    .title {
        text-align: left;
        display: inline-block;
        width: 100%;
        padding-left: 10px;
    }

    .tags-container {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        z-index: 500;
        background-color: #f8f8f8;
        border-bottom: solid 1px #ededed;
        max-width: 1024px;
        margin-left: auto;
        margin-right: auto;
    }

    .tags-title {
        font-size: 13px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
    }

    .top-tag-item {
        padding: 8px;
        border-radius: 2px;
        border: solid 1px #c8c8c8;
        background-color: #ffffff;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.3px;
        color: #555555;
    }

    .flip-text {
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.3px;
        color: #777777;
    }

    .flip-container {
        white-space: nowrap;
    }

    .non-flip-item {
        float: left;
        margin-bottom: 7px;
    }

    .input-field[type=text] {
        padding: 10px 12px 10px 12px;
        border: solid 1px #dadada;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
        caret-color: #ff8c09;
        box-sizing: border-box;
        outline: none;
        width: 100%;
    }

    .input-field[type=text]:focus {
        padding: 10px 12px 10px 12px;
        border: solid 1px #555555;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
        caret-color: #ff8c09;
        box-sizing: border-box;
        outline: none;
        width: 100%;
    }

    .search-button {
        border: solid 1px #555555;
        background-color: #555555;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.32px;
        color: #ffffff;
    }


</style>